import { useNavigate } from "react-router-dom";
import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import { getGuidelineList } from "../../utils/getConstants";

const glList = getGuidelineList();

function getIconClassName(topicDetails) {
  if (topicDetails) {
    return classNames(
      "squareIcon",
      "smallSquare",
      topicDetails.squareIconClass
    );
  }
  return classNames("squareIcon");
}

const AppTopicHeadline = ({ topicDetails, bannerText }) => {
  const navigate = useNavigate();
  const breadCrumbCaratClasses = classNames(
    style.breadcrumbCarat,
    "tg-icons-Carat"
  );
  // I leave the logic but 18 for long / short is Ok
  const iconClassNames = getIconClassName(topicDetails);
  const headerClassName = classNames(
    `${bannerText}`.length > 20 ? "size-18" : "size-18",
    "semibold"
  );
  const goTopic = () => {
    const squareIconClass = topicDetails.squareIconClass;
    const onClickProps = glList.find((itm) => itm.iconClassSuffix === squareIconClass).onClickProps;
    const chapterRoot = onClickProps.replaceAll(" ", "_");
    navigate(`/app/nav/${chapterRoot}`);
  };

  return (
    <div className={style.headline}>
      <h1 className={headerClassName}>{bannerText}</h1>
      <div
        className={classNames(style.titleBreadcrumb, "semibold", "size-12")}
        onClick={goTopic}
        role="button"
        aria-label={`${topicDetails?.text}-breadcrumb`}
      >
        <span className={iconClassNames} />
        <span className={style.descriptionBreadcrumb}>
          {topicDetails?.text}
        </span>
        <span className={breadCrumbCaratClasses}></span>
      </div>
    </div>
  );
};

export default AppTopicHeadline;